import { StateObservable } from 'redux-observable';
import { Observable } from 'rxjs';
import { ReportState } from '@sas-dvr/internal-va-react-core/store/rootReducer';
import {
  getKey,
  getLayoutData,
  getLayoutState,
  doBirdLayout,
  refreshLayoutConstraints,
} from '../util';
import { getLoaderForController, getLoaderForVisualElementController } from '../loaders';
import { AnyAction } from 'redux';

export class BirdEpicDependencies {
  getLoaderForController = getLoaderForController;
  getLoaderForVisualElementController = getLoaderForVisualElementController;
  getKey = getKey;
  getLayoutData = getLayoutData;
  refreshLayoutConstraints = refreshLayoutConstraints;
  doBirdLayout = doBirdLayout;
  getLayoutState = getLayoutState;
}

export type BirdEpic = (
  actions$: Observable<AnyAction>,
  state$: StateObservable<ReportState>,
  deps: BirdEpicDependencies
) => Observable<AnyAction>;
